import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        // Multi-Promo Button
        multiPromoButtonChevron: {
            color: 'background.neutral.blue',
            bg: 'background.neutral.default',
            borderRadius: 'full',
            boxSize: remCalc(36),
            boxShadow: 'borderShadow',
        },
        multiPromoButtonChevronIcon: {
            boxSize: remCalc(16),
            color: 'foreground.accent.default',
        },
        copyIcon: {
            boxSize: remCalc(12),
            color: 'foreground.neutral.inverse',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'center',
        },
        codeContainer: {
            color: 'foreground.neutral.inverse',
            bg: 'background.neutral.blue',
            borderRadius: 'medium-1',
            gap: remCalc(6),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            py: ['xxxsmall-1.base', 'xxxsmall-1.sm', 'xxxsmall-1.md', 'xxxsmall-1.lg'],
            px: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
            height: remCalc(24),
        },
        codeText: {
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
        },
        codeTextCopied: {
            textTransform: 'uppercase',
        },
        promoTagContainer: {
            marginBottom: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
        },
        promoCodeContainer: {
            marginTop: 0,
        },
        multiPromoButtonContentStack: {
            borderRadius: 'large-1',
            bg: 'background.promo',
            gap: remCalc(12),
            p: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            alignItems: 'flex-start',
        },
        multiPromoButton: {
            width: '100%',
            bg: 'background.promo',
            borderRadius: 'large',
            color: 'foreground.accent.default',
            height: 'auto',
            justifyContent: 'space-between',
            transition: 'background-color 0.2s',
            textStyle: 'body-small',
            fontWeight: 'medium',
            gap: remCalc(6),
        },

        // Multi-Promo Button Content Stack
        multiPromoButtonContent: {
            align: 'flex-start',
            gap: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
            flex: 1,
            w: '100%',
        },

        // Multi-Promo Button Label (icon + text)
        multiPromoButtonLabel: {
            alignSelf: 'flex-start',
        },

        multiPromoButtonTextStack: {
            align: 'flex-start',
            gap: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
        },

        // Multi-Promo Button Icon
        multiPromoButtonIcon: {
            boxSize: remCalc(14),
            flexShrink: 0,
            color: 'foreground.accent.default',
            display: 'flex',
            justifyContent: 'flex-start',
            alignSelf: 'flex-start',
        },

        // Multi-Promo Button Label Text
        multiPromoButtonLabelText: {
            fontWeight: 'medium',
            textStyle: 'body-small',
            color: 'foreground.accent.default',
            display: 'flex',
            alignItems: 'flex-start',
            alignSelf: 'flex-start',
        },

        // Multi-Promo Button Description
        multiPromoButtonDescription: {
            textStyle: 'body-small',
            color: 'foreground.accent.default',
            fontWeight: 'normal',
            opacity: 0.7,
            display: 'flex',
            alignItems: 'flex-start',
            alignSelf: 'flex-start',
        },

        multiPromoButtonContentFlex: {
            gap: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
        },

        promoSummaryWithImageLayout: {
            width: '100%',
            alignItems: 'flex-start',
            gap: ['xxsmall-1.base', 'xxsmall-1.sm', 'xxsmall-1.md', 'xxsmall-1.lg'],
        },

        promoSummaryImageBox: {
            boxSize: remCalc(84),
            borderRadius: 'medium-1',
            bg: 'lightgray',
            bgSize: 'cover',
            bgPosition: '50% 50%',
            bgRepeat: 'no-repeat',
            mixBlendMode: 'plus-darker',
            flexShrink: 0,
            alignSelf: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },

        promoSummaryDetails: {
            align: 'flex-start',
            gap: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
            flex: 1,
        },

        promoGreyLink: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
            textDecoration: 'none',
            color: 'foreground.neutral.default',
        },

        promoGreyLinkText: {
            textStyle: 'body-xsmall',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },

        promoGreyLinkIcon: {
            boxSize: remCalc(12),
            color: 'foreground.neutral.muted',
        },

        // Promo Drawer Content
        promoDrawerContent: {
            bg: 'background.neutral.default',
        },

        // Promo Drawer Header
        promoDrawerHeader: {
            py: ['small.base', 'small.sm', 'small.md', 'small.lg'],
            px: ['small.base', 'small.sm', 'small.md', 'small.lg'],
        },

        // Promo Drawer Header Flex
        promoDrawerHeaderFlex: {
            justify: 'space-between',
            align: 'center',
            width: '100%',
            gap: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
        },

        // Promo Drawer Header Title
        promoDrawerHeaderTitle: {
            fontWeight: 'medium',
            textStyle: 'body-medium',
            color: 'foreground.neutral.default',
        },

        // Promo Drawer Header Subtitle
        promoDrawerHeaderSubtitle: {
            textStyle: 'body-small',
            color: 'foreground.neutral.muted',
        },

        // Promo Drawer Body
        promoDrawerBody: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: ['small.base', 'small.sm', 'small.md', 'small.lg'],
            alignSelf: 'stretch',
            p: 0,
            borderRadius: 'large',
            bg: 'background.neutral.default',
            overflowY: 'auto',
        },

        // Promo List (VStack)
        promoList: {
            gap: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            align: 'stretch',
            width: '100%',
            px: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
        },

        // Promo Card (Individual promo in drawer)
        promoCard: {
            border: 'small',
            borderStyle: 'solid',
            borderRadius: 'large',
            borderColor: 'border.neutral.subtle',
            bg: 'background.neutral.hover',
            transition: 'box-shadow 0.2s',
        },
        promoCardDefault: {
            bg: 'background.neutral.hover',
        },
        promoCardRed: {
            bg: 'background.error.light',
        },
        promoCardGrey: {
            bg: 'background.neutral.secondary',
        },

        // Promo Drawer Close Button
        promoDrawerCloseButton: {
            position: 'static',
            width: remCalc(36),
            height: remCalc(36),
            p: remCalc(4),
            color: 'foreground.neutral.default',
        },

        // Promo Drawer Overlay
        promoDrawerOverlay: {
            bg: 'rgba(0, 0, 0, 0.5)',
        },

        promoDrawerHeaderText: {
            align: 'flex-start',
            gap: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
        },
    },
}
